<template>
  <div class="abort-selling-modal">
    <img src="@/assets/icon/warning-icon.svg" />
    <div class="title">Abort selling this item?</div>
    <div class="footer">
      <primary-button @onClick="$emit('onConfirm')" class="confirm-btn"
        >Confirm</primary-button
      >
      <filter-option-btn class="cancel-btn" @onClick="$emit('closeModal')"
        >Cancel</filter-option-btn
      >
    </div>
  </div>
</template>
<script>
import FilterOptionBtn from '@/components/BaseComponents/FilterOptionBtn.vue';
import PrimaryButton from '@/components/BaseComponents/PrimaryButton.vue';
export default {
  components: {
    FilterOptionBtn,
    PrimaryButton
  }
};
</script>
<style lang="scss" scoped>
.abort-selling-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 26px;
    font-family: Inter;
    color: #18324c;
    margin-top: 25px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
    width: 100%;
    padding: 0 30px;
    .cancel-btn {
      width: 48%;
      margin-left: 5px;
      height: 48px;
    }
    .confirm-btn {
      width: 48%;
      height: 48px;
      margin-right: 5px;
    }
  }
}
</style>
